import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import EmergencyContactFormComp from '../../../../components/registrationPacket/EmergencyContactFormComp';

const EmergencyContactForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = Boolean(id);

  useEffect(() => {

  }, []);

  return (
    <Container>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div className="header-title d-flex align-items-center">
                <i className="icon material-symbols-outlined me-2" style={{ verticalAlign: 'middle', fontSize: '22px' }}>contact_emergency</i>
                <h4 className="card-title mb-0">
                  {isEditMode ? 'Edit' : 'Add'} Emergency Contact
                </h4>
              </div>
              <Button variant="outline-secondary" onClick={() => navigate('/dashboard/emergency-contact/list')}>
                <i className="icon material-symbols-outlined me-1" style={{ verticalAlign: 'middle' }}>arrow_back</i>
                Back to List
              </Button>
            </Card.Header>
            <Card.Body>
              <EmergencyContactFormComp isEditMode={isEditMode} existingData={""} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default EmergencyContactForm;
